/*
 * © Copyright 2014 – 2025 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import jsonFetch from '../json-fetch';
import t from '../../i18n/locale-keys';

const OLD_FINGERPRINT_SERVICE_URL = 'https://127.0.0.1:8442/api/v1/fingerprint/capture';
const FINGERPRINT_SERVICE_URL = 'https://127.0.0.1:8442/api/v1/fingerprint/login';

export const RESULT_CODES = {
    WAITING_SECRET_KEY: 'WAITING_SECRET_KEY',
    FAILED: 'FAILED',
    JSON_PARSE_FAILED: 'JSON_PARSE_FAILED',
    METHOD_NOT_FOUND: 'METHOD_NOT_FOUND',
    MORE_DATA: 'MORE_DATA',
    NEW_CAPTURE: 'NEW_CAPTURE',
    OLD_CAPTURE: 'OLD_CAPTURE'
}

function getError(captureStatus) {
    if (captureStatus === 'Timeout') {
        return Promise.reject(t.fingerTimeout());
    }
    else if (captureStatus === 'NoReader') {
        return Promise.reject(t.fingerReaderNotConnected());
    }
    else if (captureStatus === 'IndexError') {
        return t.fingerIndexError();
    }
    else if (captureStatus === 'NotSupported') {
        return t.fingerReaderUnsupported();
    }
    else if (captureStatus === 'FakeFinger') {
        return t.fingerFakeError();
    }
    else if (captureStatus === 'IncorrectMode') {
        return t.fingerIncorrectMode();
    }
    else {
        return Promise.reject(captureStatus);
    }
}

// todo:   Delete this in June 2026 or later  (remove support for old way of login using old client)
export function captureFingerprint(scanIndex) {
    const options = {
        method: 'POST',
        url: OLD_FINGERPRINT_SERVICE_URL
    };
    if (scanIndex) {
        options.params = {index: scanIndex};
    }
    return jsonFetch(options)
        .catch((failedResponseData) => {
            if (failedResponseData.status) {
                return Promise.reject(t.fingerServiceError());
            }
            else {
                return Promise.reject(t.fingerServiceUnavailable());
            }
        })
        .then((data) => {
            if (!data) {
                return Promise.reject(t.fingerDetectFailed());
            }
            else if (scanIndex && Array.isArray(data)) {
                var captureStatus = 'Ok'
                data.forEach((captureArray) => {
                    const fingerCapture = JSON.parse(captureArray);
                    if (fingerCapture.captureStatus !== 'Ok') {
                        captureStatus = fingerCapture.captureStatus
                    }
                });
                if (captureStatus !== 'Ok') {
                    return getError(captureStatus);
                }
                return data;

            } else if (data.captureStatus === 'Ok') {
                return data;
            } else {
                return getError(data.captureStatus)
            }
        });
}

export function loginFingerprint(scanIndex, data) {
    const options = {
        method: 'POST',
        url: FINGERPRINT_SERVICE_URL
    };

    if (data) {
        options.data = data;
    }

    if (scanIndex) {
        options.params = {index: scanIndex};
    }
    return jsonFetch(options)
        .catch((failedResponseData) => {
            if (failedResponseData.status) {
                return Promise.reject(t.fingerServiceError());
            }
            else {
                return Promise.reject(t.fingerServiceUnavailable());
            }
        })
        .then((data) => {
            if (!data) {
                return Promise.reject(t.fingerDetectFailed());
            }
            else if (scanIndex && Array.isArray(data)) {
                var captureStatus = 'Ok'
                data.forEach((captureArray) => {
                    const fingerCapture = JSON.parse(captureArray);
                    if (fingerCapture.captureStatus !== 'Ok') {
                        captureStatus = fingerCapture.captureStatus
                    }
                });
                if (captureStatus !== 'Ok') {
                    return getError(captureStatus);
                }
                return data;

            } else if (data.captureStatus === 'Ok' || data.result === RESULT_CODES.MORE_DATA) {
                return data;
            } else {
                return getError(data.captureStatus)
            }
        });
}

// This is used to determine if we device service can support encrypting the captured data
export function fingerprintAvailable() {
    const options = {
        method: 'POST',
        url: FINGERPRINT_SERVICE_URL
    };

    return jsonFetch(options)
        .catch((failedResponseData) => {
            return Promise.reject(t.fingerServiceUnavailable());
        })
        .then((data) => {
            return data.result !== RESULT_CODES.METHOD_NOT_FOUND ? RESULT_CODES.NEW_CAPTURE : RESULT_CODES.OLD_CAPTURE;
        });
}
